<template>
  <section class="section">
    <div class="row ">
      <!-- // Main -->
      <tools-area :focus="focus" />
      <side-area
        :focus="focus"
        @close-focus-tools="$emit('close-focus-tools')"
      />
      <!-- // ToolsArea -->
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import ToolsArea from "./ToolsArea";
import SideArea from "./SideArea";

export default {
  name: "Home",
  props: ["focus"],
  components: {
    ToolsArea,
    SideArea
  }
};
</script>
